import { CSSProperties, FunctionComponent, useRef } from "react";
import { observer } from "mobx-react-lite";

import { classNames } from "primereact/utils";

import { IconProp } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { TooltipWrapper } from "../../Components/TooltipWrapper/TooltipWrapper";

import "./ActionButton.scss";

interface IActionButtonProps {
  label?: string;
  icon?: IconProp;
  id?: string;
  tooltip?: string;
  tooltipPosition?: "top" | "bottom" | "left" | "right" | "mouse";
  tooltipDisabled?: boolean;
  buttonDisabled?: boolean;
  hideBackground?: boolean;
  hideBackgroundHover?: boolean;
  hide?: boolean;
  customStyles?: CSSProperties;
  customClasses?: string;
  onClick?: (event: any) => void;
}

const RawActionButton: FunctionComponent<IActionButtonProps> = (props: IActionButtonProps) => {
  const tooltipRef = useRef<HTMLDivElement>(null);

  return (
    <div ref={tooltipRef} className={classNames(props.customClasses || "")}>
      <TooltipWrapper
        targetRef={tooltipRef}
        content={props.tooltip ?? ""}
        position={props.tooltipPosition ?? "right"}
        disabled={props.tooltipDisabled || props.hide}
      />

      <button
        className={classNames("action-button", {
          "icon-only": !props.label,
          "hide-background": props.hideBackground,
          "hide-background-hover": props.hideBackgroundHover,
          hide: props.hide,
          disabled: props.buttonDisabled,
        })}
        style={props.customStyles}
        onClick={!props.buttonDisabled ? props.onClick : undefined}
        onKeyDown={event => !props.buttonDisabled && event.key === "Enter" && props.onClick?.(event)}
        type="button"
        disabled={props.buttonDisabled}
        id={props.id ?? "action-button"}
        data-testid={props.id ?? "action-button"}
      >
        {!!props.icon && (
          <div className="action-button-icon">
            <FontAwesomeIcon icon={props.icon} />
          </div>
        )}

        {!!props.label?.length && <div className="action-button-text">{props.label}</div>}
      </button>
    </div>
  );
};

export const ActionButton = observer(RawActionButton);
